import { Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { ApiService } from 'src/app/shared/services/api.service';

@Injectable({
  providedIn: 'root'
})
export class AppHeaderService {

  storeDetailsJson = null;
  appTitle: string;
  appTitlePrefix: string;
  siteTitlePublic: string;
  featureTags={};
  storeDetails:any

  constructor(
    private title: Title,
    private router: Router,
    private route: ActivatedRoute,
    private apiService: ApiService
  ) { 
    this.featureTags = JSON.parse(sessionStorage.getItem("featureTags"));
  }

  setupAppHeader(storeDetailsJson: any, categories, vendors, pageNumber = null) {

    this.storeDetailsJson = storeDetailsJson;
    const siteTitle = this.storeDetailsJson['settings']['siteTitle'];
    this.appTitle = !!siteTitle ? siteTitle : 'Route Worx';
    this.appTitlePrefix = this.storeDetailsJson['settings']['siteTitlePrefix'];
    this.siteTitlePublic = this.storeDetailsJson['settings']['siteTitlePublic'];
    this.storeDetails = JSON.parse(sessionStorage.getItem('store'));

    this.setAppTitle(null , categories, vendors, pageNumber);
    // console.log(this.storeDetails);
    
  }

  setAppTitle(title: string = null, categories, vendors, pageNumber) {
    let parentCategory = this.router.url.split('/').length === 3 && this.router.url !== '/categories' && this.router.url.includes('categories') ? categories.filter(val => val['category_url'] === this.router.url.split('/')[2]): undefined;
    let childCategory = this.router.url.split('/').length > 3  && this.router.url !== '/categories' &&  this.router.url.includes('categories') && isNaN(parseInt(this.router.url.split('/')[3])) ? categories.reduce((arr, item) => arr.concat(item.sub_list), []).find(sub => sub.category_url === this.router.url.split('/')[3]) :  isNaN(parseInt(this.router.url.split('/')[3])) === false ? vendors.filter(el => el['id'] === parseInt(this.router.url.split('/')[3])) : undefined;
    const vendorsTitle = this.router.url.split('/');
    let newTitle = this.appTitle;
    if(!!title) {
      newTitle = title;
    }else if (parentCategory && childCategory && isNaN(parseInt(this.router.url.split('/')[3]))) {
      newTitle = `${parentCategory[0]['category_name'].replace('&amp;','&')} > ${childCategory['category_name'].replace('&amp;','&')}`;
    }else if (childCategory && isNaN(parseInt(this.router.url.split('/')[3]))) {
      newTitle = childCategory['category_name'] ? childCategory['category_name'].replace('&amp;','&') : childCategory['vendor_name'].replace('&amp;','&');
    }else if (this.router.url.includes('vendors') && vendorsTitle.length >= 3) {
      const vendorName = this.capitalizeEachWord(vendorsTitle[2].replace('_', ' '));
      const routeTitle = this.getAppTitleFromRoute();
      newTitle = routeTitle ? `${routeTitle} - ${vendorName}` : vendorName;
    } else {
      let routeTitle = this.getAppTitleFromRoute();
      if(routeTitle === "Home"){
        newTitle = this.appTitlePrefix
      }else{
        newTitle = !!routeTitle ? routeTitle : this.appTitle;
      }
    }
    const capitalizedTitle = this.capitalizeEachWord(newTitle);
    
    if (!!this.featureTags && this.featureTags['sf_seo']) {
      if (!this.router.url.includes('categories') && !this.router.url.includes('vendors')) {
        this.title.setTitle(`${capitalizedTitle} - ${this.storeDetails.name}`);
      } else if (this.router.url.includes('vendors')) {
        this.title.setTitle(`${newTitle} - ${this.storeDetails.name}`);
      // } else if (
      //   (this.router.url.includes('vendors') || this.router.url.includes('categories')) &&
      //   !this.title.getTitle().includes(this.storeDetails.name)
      // ) {
      //   this.title.setTitle(`${this.title.getTitle()} - ${this.storeDetails.name}`);
      } else if (this.router.url.includes('categories')) {          
        const currentUrl = this.router.url;
  
        // Extract 'parentCategory' and 'subCategory' fr om the URL
        const urlSegments = currentUrl.split('/');
        const parentCategoryParam = urlSegments.length > 2 ? urlSegments[2].split('?')[0]: null; // 2nd part of the URL
        const subCategoryParam = urlSegments.length > 3 ? urlSegments[3].split('?')[0] : null; // 3rd part if exists          
  
        // Check if the URL contains query parameters
        let queryParams = currentUrl.split('?')[1]; // Extract query params
        let page = queryParams ? new URLSearchParams(queryParams).get('page') : null;
        page = page == '1' ? null : page;
        if (pageNumber == 1) {
          page = null;
        }
        
        if (!parentCategoryParam) {          
          return;
        }
  
        const parentCategoryIndex = categories.findIndex(val => val['category_url'] === parentCategoryParam);
        const subCategoryIndex = !!subCategoryParam  && parentCategoryIndex > -1 ? categories[parentCategoryIndex]['sub_list'].findIndex(val => val['category_url'] === subCategoryParam) : null;        
        
        var dynamicTitle = !!subCategoryParam
          ? parentCategoryIndex > -1 && subCategoryIndex > -1
            ? `${categories[parentCategoryIndex]['category_name'].replace('&amp;', '&')} - ${categories[parentCategoryIndex]['sub_list'][subCategoryIndex]['category_name'].replace('&amp;', '&')} `
            : subCategoryParam ? subCategoryParam.toUpperCase().replace('&amp;', '&') : ''
          : parentCategoryIndex > -1
            ? `${categories[parentCategoryIndex]['category_name'].replace('&amp;', '&')}`
            : '';
  
        dynamicTitle = this.capitalizeEachWord(dynamicTitle);
        
        var finalTitle = !!this.storeDetails.name ? page ? `${dynamicTitle} (Page ${page}) - ${this.storeDetails.name}` :dynamicTitle + ' - ' + this.storeDetails.name: dynamicTitle;
        
        this.title.setTitle(finalTitle);
      } 
    }else{
      if (this.router.url.includes('index')) {
        this.title.setTitle(`${this.appTitlePrefix} - ${this.siteTitlePublic}`);
      } else if (!this.router.url.includes('categories') && !this.router.url.includes('vendors')) {
        this.title.setTitle(`${capitalizedTitle} - ${this.appTitlePrefix}`);
      } else if (this.router.url.includes('vendors')) {
        this.title.setTitle(`${newTitle} - ${this.appTitlePrefix}`);
      } else if (
        (this.router.url.includes('vendors') || this.router.url.includes('categories')) &&
        !this.title.getTitle().includes(this.appTitlePrefix)
      ) {
        this.title.setTitle(`${this.title.getTitle()} - ${this.appTitlePrefix}`);
      }  
    }
  }
  
  capitalizeEachWord(text: string): string {
    if (!text) return text; // Handle empty strings
    return text
      .split(' ') // Split into words
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) // Capitalize each word
      .join(' '); // Join words back together
  }
  

  
  getAppTitleFromRoute() {
    let child = this.route.firstChild;
      while (child.firstChild) {
        child = child.firstChild;
      }
      if (child.snapshot.data['title']) {
        return child.snapshot.data['title'];
      }
      return null;
  }

}
